import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  assetId: string;
  linkId: string;
};

const [useDeleteAssetDirectLink, deleteAssetDirectLink] = createAsyncAction(
  "assets/deleteDirectLink",
  async ({ assetId, linkId }: Args) => {
    const res = await API.call<{ directLink: number }>({
      endpoint: `assets/${assetId}/direct_links/${linkId}`,
      method: "DELETE",
    });
    return { ...res, result: res.result.directLink };
  }
);

export default useDeleteAssetDirectLink;
export { deleteAssetDirectLink };
